// global.$ = global.jQuery = require('jquery');
import { createApp } from 'vue'
import mitt from 'mitt'
import ChartView from '@vueapp/views/Chart.vue'

import VueTippy from 'vue-tippy'

export class Chart {

    constructor( elements ) {

        let _this = this

        if ( elements.length ) {
            elements.forEach(function (item, key) {
                const emitter = mitt()
                const app = createApp(ChartView, {
                    postId: item.getAttribute('data-post-id'),
                    postSlug: item.getAttribute('data-post-slug'),
                    verticalRatio: item.getAttribute('data-vertical-ratio'),
                    columnRatio: item.getAttribute('data-column-ratio'),
                    verticalSpan: item.getAttribute('data-vertical-span'),
                })
                app.config.globalProperties.emitter = emitter
                app.mount('#' + item.getAttribute('id') )

                app.use(
                    VueTippy,
                    // optional
                    {
                        directive: 'tippy', // => v-tippy
                        component: 'tippy', // => <tippy/>
                        componentSingleton: 'tippy-singleton', // => <tippy-singleton/>,

                        defaultProps: {
                            // placement: 'auto-end',
                            allowHTML: true,
                            theme: 'bryter',
                            placement: 'right',
                        }, // => Global default options * see all props
                    }
                )
            })
        }


    }


}